import { Package } from "@/types/api";
import { useMemo } from "react";

// Static imports as fallback
import Package1Full from "../assets/Package1.png";
import Package1Preview from "../assets/Package1_preview.jpg";
import Package2Full from "../assets/Package2.png";
import Package2Preview from "../assets/Package2_preview.jpg";
import Package3Full from "../assets/Package3.png";
import Package3Preview from "../assets/Package3_preview.jpg";

interface PackageImages {
  previewImage: string;
  packageImage: string;
}

export function usePackageImages(pkg: Package | null): PackageImages {
  return useMemo(() => {
    if (!pkg) {
      return { previewImage: Package1Preview, packageImage: Package1Full };
    }

    // Use storage URLs if available
    if (pkg.previewImageUrl && pkg.packageImageUrl) {
      return {
        previewImage: pkg.previewImageUrl,
        packageImage: pkg.packageImageUrl,
      };
    }

    // Fallback to static imports
    const packageNumber = pkg.name.includes("1")
      ? "1"
      : pkg.name.includes("2")
        ? "2"
        : "3";

    const staticImages = {
      "1": { preview: Package1Preview, package: Package1Full },
      "2": { preview: Package2Preview, package: Package2Full },
      "3": { preview: Package3Preview, package: Package3Full },
    };

    return {
      previewImage: staticImages[packageNumber].preview,
      packageImage: staticImages[packageNumber].package,
    };
  }, [pkg]);
}
